import { api } from "../axiosInstance/axiosInstance";

export const getUser = async (setUser: Function) => {
  try {
    const response = await api.get(`/my-user`);
    localStorage.removeItem("usuario");
    localStorage.setItem("usuario", JSON.stringify(response.data));
    setUser(response.data)
    return response.data;

  } catch (error) {
    alert('Ocorreu um erro ao buscar o usuário')
  }

}
